import { parse as parseParams } from 'hub-http/helpers/params';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getPageViewedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useEffect, useRef } from 'react';
import { SuggestionSection } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
import { useAppContext } from '../context/AppContext';

type HomepageViewedProps = Pick<
  ReturnType<typeof getPageViewedEvent>['eventProps'],
  'screen' | 'type' | 'slug'
>;

type UseTrackHomepageViewedEventProps = HomepageViewedProps & {
  loading: boolean;
  sections?: SuggestionSection[];
};

export function useTrackHomepageViewedEvent({
  loading,
  sections,
  ...rest
}: UseTrackHomepageViewedEventProps) {
  const appContext = useAppContext();
  const params = parseParams(window.location.search.slice(1));
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const eventSentRef = useRef(false);

  useEffect(() => {
    if (!loading && !eventSentRef.current) {
      eventSentRef.current = true;
      const sectionStrings = sections?.map(
        (section, index) => `${index}__${String(section.sectionType)}`
      );
      trackMarketplaceEvent(
        getPageViewedEvent({
          ...rest,
          inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
          sections: sectionStrings,
          embed: true,
          referrer:
            typeof params.referrer === 'string' ? params.referrer : undefined,
        })
      );
    }
  }, [appContext, loading, params, rest, sections, trackMarketplaceEvent]);
}
